// Services
import { saveIbanAccountService } from '../services/financial-data.service';
// Utilities
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';

const saveIbanAccountResolver = async (iban: string): Promise<[boolean] | [null, boolean]> => {
  const [, { status }] = await saveIbanAccountService(iban);

  return requestHasSuccessStatus(status) ? [true] : [null, true];
};

export { saveIbanAccountResolver };
